'use client'
import { Quantum } from 'ldrs/react'

export default function Loader() {
  return (
    <div className="flex justify-center items-center p-4">
      <Quantum size={45} speed={1.75} color="#4f46e5" />
    </div>
  )
}
